
import classes from "./postCard.module.css";

const PostCard = ({
  id,
  imageUrl,
  imageAlt = "Post image",
  date,
  title,
  description,
  onButtonClick,
}) => {


  return (
    <div className={classes.PostMainContainer}>
        <div className={classes.PostImageContainer}>
          <img src={imageUrl} alt={imageAlt} />
        </div>
        <div className={classes.PostContentContainer}>
          <div className={classes.postDate}>{date}</div>
          <div className={classes.postTitle}>{title}</div>
          <div className={classes.PostDescription}>{description}</div>
        </div>
    </div>
  );
};

export default PostCard;
